import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class PostulacionesService {

  constructor(private http: HttpClient) { }

  public guardarPostulacion(postulacion){
    return this.http.post(GlobalVariable.API_SERVER_URL+"postulacion",postulacion,GlobalVariable.httpOptions);
  }

  public obtenerPostulacionPorCodigo(codigo){
    return this.http.get(GlobalVariable.API_SERVER_URL+"formulario-postulacion/"+codigo,GlobalVariable.httpOptions);
  }

  public obtenerListaPostulaciones(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"postulacion/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public enviarDatosPostulacion(postulacion){
    return this.http.post(GlobalVariable.API_SERVER_URL+"datos-postulacion",postulacion,GlobalVariable.httpOptions);
  }
}
